var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeOfPolyphase01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.22,13.76c-3.11,0-5.65-2.53-5.65-5.65s2.53-5.65,5.65-5.65S14.87,5,14.87,8.11S12.34,13.76,9.22,13.76z  M9.22,2.97c-2.84,0-5.15,2.31-5.15,5.15c0,2.84,2.31,5.15,5.15,5.15c2.84,0,5.15-2.31,5.15-5.15C14.37,5.28,12.06,2.97,9.22,2.97z "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.56,
    y: 7.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.9681 8.9248)",
    className: "st2",
    width: 15.46,
    height: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.71,8.08l0.42-0.06c0.05,0.24,0.13,0.41,0.25,0.52S1.64,8.7,1.8,8.7c0.2,0,0.37-0.07,0.5-0.21 c0.14-0.14,0.21-0.31,0.21-0.51c0-0.19-0.06-0.35-0.19-0.48C2.19,7.38,2.03,7.32,1.84,7.32c-0.08,0-0.18,0.02-0.3,0.05L1.59,7 c0.03,0,0.05,0,0.07,0C1.83,7,2,6.95,2.14,6.86c0.14-0.09,0.22-0.24,0.22-0.43c0-0.15-0.05-0.28-0.16-0.38s-0.24-0.15-0.4-0.15 c-0.16,0-0.3,0.05-0.41,0.15C1.28,6.15,1.21,6.3,1.17,6.51L0.75,6.44C0.8,6.15,0.92,5.93,1.1,5.78c0.18-0.16,0.41-0.23,0.68-0.23 c0.19,0,0.36,0.04,0.52,0.12C2.46,5.75,2.58,5.86,2.66,6c0.08,0.14,0.13,0.29,0.13,0.44c0,0.15-0.04,0.28-0.12,0.4 c-0.08,0.12-0.2,0.22-0.35,0.29c0.2,0.05,0.36,0.14,0.47,0.29C2.9,7.57,2.96,7.75,2.96,7.98c0,0.3-0.11,0.55-0.33,0.76 C2.41,8.95,2.13,9.05,1.8,9.05c-0.3,0-0.55-0.09-0.75-0.27C0.85,8.6,0.74,8.37,0.71,8.08z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeOfPolyphase01);
export default __webpack_public_path__ + "static/media/ThreeOfPolyphase-01.60855fc411cd96524a6ef370bdd933a3.svg";
export { ForwardRef as ReactComponent };